/*eslint-disable sort-keys/sort-keys-fix */
const sellerSortOrders = {
    UPCOMING_LOWEST_FIRST: 'UPCOMING_LOWEST_FIRST',
    UPCOMING_HIGHEST_FIRST: 'UPCOMING_HIGHEST_FIRST',
    NAME_LOWEST_FIRST: 'NAME_LOWEST_FIRST',
    NAME_HIGHEST_FIRST: 'NAME_HIGHEST_FIRST',
} as const;

export default sellerSortOrders;
